import { isDriverWorkPausedError } from "@repo/types";
import { t } from "i18next";

/** Translated refusal when the API blocks work for a driver paused by an expired document. */
export function driverPausedErrorMessage(error: unknown): string | null {
  return isDriverWorkPausedError(error) ? t("driver.expiryPause.workRefused") : null;
}
